(() => {
  const selector = '.kl-teaser-TEpp5s';
  const observed = new WeakSet();
  function update(teaser) {
    const label = teaser.querySelector('[role="button"]');
    if (!label) return;
    const walker = document.createTreeWalker(label, NodeFilter.SHOW_TEXT);
    while (walker.nextNode()) {
      const node = walker.currentNode;
      if (/^\s*Save 10%\s*→\s*$/.test(node.nodeValue)) node.nodeValue = 'Save 10%';
    }
  }
  function attach(teaser) {
    if (observed.has(teaser)) return;
    observed.add(teaser);
    update(teaser);
    new MutationObserver(() => update(teaser)).observe(teaser, { childList: true, subtree: true, characterData: true });
  }
  document.querySelectorAll(selector).forEach(attach);
  new MutationObserver(records => {
    for (const record of records) for (const node of record.addedNodes) {
      if (node.nodeType !== Node.ELEMENT_NODE) continue;
      if (node.matches(selector)) attach(node);
      else node.querySelectorAll(selector).forEach(attach);
    }
  }).observe(document.body, { childList: true, subtree: true });
})();
